import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header-print',
  templateUrl: './header-print.component.html',
  styleUrls: ['./header-print.component.scss']
})
export class HeaderPrintComponent implements OnInit {

  @Input() title = null;
  @Input() numberOfStep = null;
  @Input() subtitle = null;

  constructor() { }

  ngOnInit() {
  }

}
